import { extendTheme, type ThemeConfig } from '@chakra-ui/react'

// Define color mode config
const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
}

// Define custom colors
const colors = {
  brand: {
    50: '#e5f0ff',
    100: '#b8d3ff',
    200: '#8ab5ff',
    300: '#5c98ff',
    400: '#2e7aff',
    500: '#0461e6',
    600: '#004bb4',
    700: '#003582',
    800: '#002051',
    900: '#000b21',
  },
}

// Define custom styles
const styles = {
  global: {
    body: {
      bg: 'gray.50',
      color: 'gray.800',
    },
  },
}

// Define custom components
const components = {
  Button: {
    baseStyle: {
      fontWeight: 'semibold',
      borderRadius: 'md',
    },
  },
  Heading: {
    baseStyle: {
      fontWeight: 'bold',
    },
  },
  Table: {
    variants: {
      simple: {
        th: {
          borderBottom: '1px',
          borderColor: 'gray.200',
          fontWeight: 'semibold',
          textTransform: 'none',
        },
        td: {
          borderBottom: '1px',
          borderColor: 'gray.100',
        },
      },
    },
  },
}

// Create the theme
const theme = extendTheme({
  config,
  colors,
  styles,
  components,
  fonts: {
    heading: `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
    body: `'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  },
})

export default theme
